const createSharedData = () => ({
  payload: {
    place_id: '',
    active: true,
    goal_percentage: '',
    business_plan_segment: []
  },
  tableHead: [
    { columnText: 'Produto', id: 1 },
    { columnText: 'Volume base', id: 2 },
    { columnText: 'Volume atual', id: 3 },
    { columnText: 'Faturamento base', id: 4 },
    { columnText: 'Faturamento atual', id: 5 }
  ],
  tableColumns: {
    volumeBase: [],
    currentVolume: [],
    revenue: [],
    iconName: [],
    currentRevenue: []
  }
});

export default createSharedData;
